import * as React from 'react'
const SvgIcoHoraireOuv = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 200 200'
    {...props}
  >
    <style>
      {
        '.ICO_HoraireOuv_N_svg__st0{display:none}.ICO_HoraireOuv_N_svg__st1{display:inline}.ICO_HoraireOuv_N_svg__st2{fill:#7984ba}.ICO_HoraireOuv_N_svg__st3,.ICO_HoraireOuv_N_svg__st4{fill-rule:evenodd;clip-rule:evenodd}.ICO_HoraireOuv_N_svg__st4{fill:#7984ba}'
      }
    </style>
    <g id='ICO_HoraireOuv_N_svg__Calque_7'>
      <path
        d='M129.66 86.58c-.4-3.85-1.68-7.47-3.6-10.84-3.89-6.8-9.69-11.1-17.2-13.16-1.8-.49-3.63-.78-5.5-.85-7.09-.28-13.39 1.87-18.87 6.33-4.96 4.03-8.02 9.27-9.43 15.48-.45 1.97-.71 3.97-.64 5.98.2 6.55 2.35 12.39 6.58 17.41 1.66 1.97 3.52 3.64 5.55 5.01l-1.76 1.76a2.36 2.36 0 0 0 0 3.35c.93.93 2.43.93 3.35 0l2.74-2.74c1.5.65 3.06 1.19 4.7 1.61 2.3.58 4.65.9 7.03.82 3.82-.12 7.45-.95 10.86-2.51l2.83 2.83c.93.93 2.43.93 3.35 0 .93-.93.93-2.43 0-3.35l-1.9-1.9c5.79-3.96 9.47-9.49 11.22-16.42.44-1.75.78-3.53.84-5.34l-.01-.77c-.02-.75-.06-1.97-.14-2.7m-4.77 4.29c-.19 3.22-1.06 6.24-2.58 9.09-1.39 2.61-3.27 4.83-5.52 6.75a21.9 21.9 0 0 1-9.32 4.71c-1.78.42-3.59.61-4.81.6-5.9.01-10.66-1.56-14.8-4.88-4.05-3.24-6.82-7.35-8.07-12.43-.61-2.47-.73-4.97-.55-7.49.3-4.09 1.64-7.82 4.05-11.14 3.25-4.49 7.51-7.56 12.91-8.97 2.36-.62 4.76-.79 7.2-.67 4.74.23 9 1.8 12.73 4.74 4.32 3.41 7.19 7.77 8.35 13.19.46 2.14.54 4.32.41 6.5'
        className='ICO_HoraireOuv_N_svg__st3'
      />
      <path
        d='M103.47 85.41v-9.58c0-.45-.11-.87-.36-1.25-.34-.51-1.1-.76-1.66-.55-.73.28-1.11.87-1.11 1.75 0 3.16 0 6.31.01 9.47a4.04 4.04 0 0 0-2.44 2.52H86.93c-.7 0-1.27.57-1.27 1.27s.57 1.27 1.27 1.27h11.24c.68 1.93 2.02 2.45 3.56 2.45 2.23 0 4.04-1.65 4.04-3.88-.01-1.6-.94-2.82-2.3-3.47M75.35 74.87c1.67-3.38 4.02-6.34 7.1-8.84 2.66-2.16 5.52-3.78 8.56-4.84a10.5 10.5 0 0 0-8.82-4.79c-5.8 0-10.51 4.7-10.51 10.51a10.54 10.54 0 0 0 3.67 7.96M128.66 74.87c2.24-1.93 3.67-4.78 3.67-7.97 0-5.8-4.7-10.51-10.51-10.51-3.69 0-6.94 1.91-8.82 4.79 3.04 1.06 5.9 2.68 8.56 4.84 3.09 2.5 5.43 5.47 7.1 8.85'
        className='ICO_HoraireOuv_N_svg__st3'
      />
    </g>
  </svg>
)
export default SvgIcoHoraireOuv

